module.exports = {"pathContext":{"slug":"/en/tutoring/","langKey":"en"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/en-tutoring.json
// module id = 1563
// module chunks = 131539946758196